import { DATE_FORMATS } from "constant";
import moment from "moment";

export const dateTransform = (
  value,
  format = DATE_FORMATS.FULL_MONTH_DAY_YEAR,
) => {
  return moment(value).format(format);
};
